module.exports = require("draft-js");


//////////////////
// WEBPACK FOOTER
// external "draft-js"
// module id = 12
// module chunks = 0